
(function () {
  const ROOT_SELECTOR = '[data-sticky-atc-root]';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function setCssVar(name, value) {
    document.documentElement.style.setProperty(name, value);
  }

  function getMainAtcButton(stickyRoot) {
    const productInfo = document.querySelector('product-info');
    const candidates = [
      'button[id^="ProductSubmitButton-"]',
      'button[name="add"]',
      '.product-form__submit'
    ];

    for (const sel of candidates) {
      const btn = productInfo ? qs(sel, productInfo) : null;
      if (btn) return btn;
    }

    const btns = qsa('button[id^="ProductSubmitButton-"]');
    for (const btn of btns) {
      if (!stickyRoot.contains(btn)) return btn;
    }

    const submitBtns = qsa('.product-form__submit');
    for (const btn of submitBtns) {
      if (!stickyRoot.contains(btn)) return btn;
    }
    return null;
  }

  function getStickyForm(stickyRoot) {
    return (
      qs('form[action^="/cart/add"]', stickyRoot) ||
      qs('form', stickyRoot)
    );
  }

  function getCartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function setVisible(stickyRoot, visible) {
    stickyRoot.classList.toggle('is-visible', visible);
    stickyRoot.setAttribute('aria-hidden', visible ? 'false' : 'true');
    document.body.classList.toggle('sticky-atc-bar-enabled', visible);

    if (visible) {
      const h = stickyRoot.offsetHeight || 0;
      setCssVar('--sticky-atc-bar-height', `${h}px`);
    } else {
      setCssVar('--sticky-atc-bar-height', '0px');
    }
  }

  function bindVisibility(stickyRoot) {
    const mainBtn = getMainAtcButton(stickyRoot);
    if (!mainBtn) return;

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries && entries[0];
        const mainVisible = !!entry && entry.isIntersecting && entry.intersectionRatio > 0;
        setVisible(stickyRoot, !mainVisible);
      },
      { threshold: 0.01 }
    );

    io.observe(mainBtn);

    const ro = new ResizeObserver(() => {
      if (stickyRoot.classList.contains('is-visible')) {
        const h = stickyRoot.offsetHeight || 0;
        setCssVar('--sticky-atc-bar-height', `${h}px`);
      }
    });
    ro.observe(stickyRoot);
  }

  function setLoadingState(submitButton, loading) {
    if (!submitButton) return;

    const spinner = submitButton.querySelector('.loading__spinner');

    if (loading) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      submitButton.removeAttribute('aria-disabled');
      submitButton.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  async function handleStickySubmit(e, stickyRoot) {
    e.preventDefault();

    const form = e.currentTarget;
    const submitButton = qs('[name="add"]', form);
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

    const cart = getCartComponent();

    const formData = new FormData(form);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sections = cart.getSectionsToRender().map((s) => s.id);
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    if (config.headers['Content-Type']) delete config.headers['Content-Type'];
    config.body = formData;

    const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    const variantId = formData.get('id');

    try {
      setLoadingState(submitButton, true);

      const response = await fetch(cartAddUrl, config);
      const parsedState = await response.json();

      if (parsedState && parsedState.status) {
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartError) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'sticky-atc-bar',
            productVariantId: variantId,
            errors: parsedState.errors || parsedState.description,
            message: parsedState.message,
          });
        }
        console.error('[sticky-atc-bar] cart/add error:', parsedState);
        return;
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'sticky-atc-bar',
          productVariantId: variantId,
          cartData: parsedState,
        });
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(parsedState);
        if (cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      }
    } catch (err) {
      console.error('[sticky-atc-bar] submit failed:', err);
    } finally {
      setLoadingState(submitButton, false);
    }
  }

  function bindAjaxAddToCart(stickyRoot) {
    const form = getStickyForm(stickyRoot);
    if (!form) return;

    if (form.dataset.stickyAjaxBound === '1') return;
    form.dataset.stickyAjaxBound = '1';

    form.addEventListener('submit', (e) => handleStickySubmit(e, stickyRoot));
  }

  function initOne(stickyRoot) {
    if (!stickyRoot || stickyRoot.dataset.initialized === '1') return;
    stickyRoot.dataset.initialized = '1';

    setVisible(stickyRoot, false);
    bindVisibility(stickyRoot);
    bindAjaxAddToCart(stickyRoot);
  }

  function initAll() {
    qsa(ROOT_SELECTOR).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();


